// Shared per-cell helpers used by both the grid (display) and the orchestrator (dirty tracking),
// so the two agree on exactly what a cell's canonical string and applicability are.

import { encodeCell } from './codec'
import { fieldDefFor } from './columns'

// key for a cell in the sparse dirty overlay;   can't occur in ids/column keys
export function dirtyKey(entryId: string, columnKey: string): string {
	return entryId + ' ' + columnKey
}

// whether a column is meaningful for a given row (false => greyed-out, non-editable cell)
export function cellApplies(typeLookup: any, entry: any, column: any): boolean {
	if (column.kind === 'sys') return true
	return !!fieldDefFor(typeLookup, entry, column.fieldId)
}

// the cell's canonical string as loaded from the (frozen) entry, before any edit
export function originalCellString(typeLookup: any, entry: any, column: any): string {
	if (column.kind === 'sys') {
		// new (unsaved) rows have a local placeholder id; show it blank so the user types the
		// real target id into the cell (empty => create with a generated id on save)
		if (column.key === 'sys.id') return entry.sys?._new ? '' : entry.sys.id
		if (column.key === 'sys.contentType') return entry.sys?.contentType?.sys?.id ?? ''
		return ''
	}
	const field = fieldDefFor(typeLookup, entry, column.fieldId)
	if (!field) return ''
	return encodeCell(entry.fields?.[column.fieldId]?.[column.locale], field)
}
